import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import FrasbergStarfieldLayout from "./layouts/FrasbergStarfieldLayout";
import Home from "./pages/Home";
import Generator from "./pages/Generator";
import Gallery from "./pages/Gallery";
import Share from "./pages/Share";
import Models from "./pages/Models";
import Legal from "./pages/Legal";
import TextToSpeech from "./pages/TextToSpeech";
import ApiDocs from "./pages/ApiDocs";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <FrasbergStarfieldLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/create" element={<Generator />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/models" element={<Models />} />
              <Route path="/tts" element={<TextToSpeech />} />
              <Route path="/developers" element={<ApiDocs />} />
              <Route path="/legal/:doc" element={<Legal />} />
              <Route path="/s/:id" element={<Share />} />
            </Routes>
          </FrasbergStarfieldLayout>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
